import React, { useMemo } from 'react';
import Tag from '../../../../components/Display/Tag';
import { getImage } from '../../../../utils/imageHelper';
import moment from 'moment';
import { CONSTANT, getConstant } from '../../../../utils/constants';
import { SpeedDial } from 'primereact/speeddial';
import { Button } from 'primereact/button';

function NewsItem({ news, handleClickNews, handleDuplicateNews }) {
  const actions = [
    {
      template: () => (
        <Button
          rounded
          icon="pi pi-eye"
          className="h-12 w-12"
          tooltip="Voir l'article"
          onClick={handleClickNews}
          severity="secondary"
        />
      )
    },
    {
      template: () => (
        <Button
          rounded
          icon="pi pi-clone"
          className="h-12 w-12"
          tooltip="Dupliquer l'article"
          onClick={handleDuplicateNews}
          severity="info"
        />
      )
    }
  ];

  return (
    <div className="flex flex-row items-center py-5 px-3 gap-x-5 cursor-pointer hover:bg-slate-100 w-full h-44">
      <img
        className="h-32 w-32 object-cover shadow-md block rounded-md"
        src={news.image ? news.image.file : getImage('img-ph.png')}
        alt={news.image ? news.image.label : 'Non renseignée'}
      />
      <div className="flex flex-col justify-around h-full w-full">
        <div className="flex flex-col gap-y-1">
          <div className="text-xl font-bold text-slate-700 ">{news.title}</div>
          <span className="font-medium text-slate-700">
            {moment(news.publication_date).format('LL')}
          </span>
        </div>
        <div className="flex flex-row gap-x-3">
          <Tag
            tag={{
              label: getConstant('bassecour.newsTypes', news.type).label,
              icon: 'star',
              bgColor: 'bg-sky-950'
            }}
          />
        </div>
      </div>
      <SpeedDial
        key="event-deletion"
        className="relative  right-3 text-xs "
        buttonClassName={'!h-12 !w-12'}
        model={actions}
        direction="left"
        rotateAnimation={false}
        showIcon="pi pi-ellipsis-v"
        hideIcon="pi pi-times"
      />
    </div>
  );
}

export default NewsItem;
